import { LogoLoadingSpinner } from "~/components/LoadingSpinner";
import { Button } from "~/components/ui/button";
import { api } from "~/utils/api";
import { HomeAssetPerformanceCards } from "./HomeAssetPerformanceCards";

// // // //

function PerformanceLoadingCard() {
    return (
        <div
            role="status"
            aria-label="Loading asset performance"
            className="col-span-12 overflow-hidden rounded-lg border bg-card shadow-xs"
        >
            <p className="px-5 pt-5 pb-4 text-xl leading-tight text-foreground">
                Tokenized Asset Performance
            </p>
            <div
                aria-hidden="true"
                className="flex h-[428px] items-center justify-center border-t"
            >
                <LogoLoadingSpinner size={75} />
            </div>
            <div aria-hidden="true" className="h-9 border-t" />
        </div>
    );
}

/** Fetch independently after hydration; never delay homepage generation or other queries. */
export function HomeAssetPerformance() {
    const { data, isLoading, isError, refetch } =
        api.assetClassesV4.performance.useQuery(undefined, {
            staleTime: 60 * 60 * 1000,
            refetchOnWindowFocus: false,
            // The server already retries upstream failures; allow an explicit retry here.
            retry: false,
            trpc: { ssr: false, context: { skipBatch: true } },
        });

    if (isLoading) return <PerformanceLoadingCard />;
    if (
        data &&
        Object.values(data).some((period) => period.series.length > 0)
    ) {
        return <HomeAssetPerformanceCards performanceByPeriod={data} />;
    }

    return (
        <div className="col-span-12 overflow-hidden rounded-lg border bg-card shadow-xs">
            <p className="px-5 pt-5 pb-4 text-xl leading-tight text-foreground">
                Tokenized Asset Performance
            </p>
            <div className="flex min-h-[428px] flex-col items-center justify-center gap-3 border-t p-5">
                <p
                    role={isError ? "alert" : "status"}
                    className="text-sm text-muted-foreground"
                >
                    {isError
                        ? "Unable to load asset performance."
                        : "No performance data available."}
                </p>
                {isError && (
                    <Button
                        variant="outline"
                        size="sm"
                        onClick={() => void refetch()}
                    >
                        Try again
                    </Button>
                )}
            </div>
        </div>
    );
}
